/**
 * ds2 C2·E1 — 시도 «표시» 라벨·시도 칩(순수 · 2026-10-16 ds2-r).
 *
 * C2: 통합 시·도 짧은 이름(regions.short_name 「전남광주」)은 화면에서 「전남·광주」로 낸다 — 두 시도 약칭이 붙은 4글자일 때만.
 *     slug·URL·title·h1·데이터 키는 그대로(표시 전용).
 * E1: 칩은 «시도 단위» 만(시군구 「춘천시」 혼입 금지) · 6개 · 고정 정렬. 인기 검색어(v_search_top_keywords_clean)가 아니라
 *     이 고정 목록을 쓴다 — 방문자·시점과 무관한 같은 6개(ISR 결정성).
 * 통합(cc_hc3_int) — components/ds/v3 에서 옮김(그 디렉터리는 지역명 0 잠금 G9 범위). 17 시도 목록은 lib/regions REGIONS 단일 출처.
 */
import { REGIONS } from '@/lib/regions';

export const SIDO_SHORT = REGIONS;

const SHORT_SET: ReadonlySet<string> = new Set(SIDO_SHORT);

/** 「전남광주」 → 「전남·광주」. 그 밖은 그대로. */
export function sidoDisplayLabel(label: string | null | undefined): string {
  const s = String(label ?? '').trim();
  if (s.length === 4 && SHORT_SET.has(s.slice(0, 2)) && SHORT_SET.has(s.slice(2))) return `${s.slice(0, 2)}·${s.slice(2)}`;
  return s;
}

/** E1 — 시도 칩 6개 고정 정렬(수도권 → 부울경 순 · 운영 유입 상위 시도). */
export const SIDO_CHIPS_6 = ['서울', '경기', '인천', '부산', '경남', '대구'] as const;
